import React, { useState } from "react";
import { auth } from "../firebaseConfig";
import { reauthenticateWithCredential, updatePassword, EmailAuthProvider } from "firebase/auth";
import { Card, Form, Button, Alert, Spinner } from "react-bootstrap";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";

export default function ChangePasswordPage() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState("");

  const handleChangePassword = async () => {
    if (!currentPassword || !newPassword) {
      setFeedback("Please fill out both fields.");
      return;
    }

    setLoading(true);
    setFeedback("");

    try {
      const user = auth.currentUser;

      if (!user) {
        setFeedback("User is not logged in.");
        setLoading(false);
        return;
      }

      // Reauthenticate the user
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      await reauthenticateWithCredential(user, credential);

      // Update the password
      await updatePassword(user, newPassword);

      setFeedback("Password updated successfully.");
      setCurrentPassword("");
      setNewPassword("");
    } catch (error) {
      console.error("Error updating password:", error);
      if (error.code === "auth/wrong-password") {
        setFeedback("The current password is incorrect.");
      } else if (error.code === "auth/weak-password") {
        setFeedback("The new password is too weak.");
      } else {
        setFeedback("Failed to update password. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <h4 className="main-title mb-4">Change Password</h4>

        {feedback && <Alert variant={feedback.includes("success") ? "success" : "danger"}>{feedback}</Alert>}

        <Card className="shadow-sm mb-4">
          <Card.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Current Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter your current password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter a new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </Form.Group>

              <Button variant="primary" onClick={handleChangePassword} disabled={loading}>
                {loading ? <Spinner animation="border" size="sm" /> : "Update Password"}
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </div>
      <Footer />
    </React.Fragment>
  );
}
